// extracted by mini-css-extract-plugin
export default {"root":"EmptyState_root__7dc-S","icon":"EmptyState_icon__74n9a","title":"EmptyState_title__qpA3H","text":"EmptyState_text__D9VlS","action":"EmptyState_action__UmIoA"};